import { Chart as ChartJS, registerables } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(...registerables);

interface ParticipationCardProps {
  selectedTopic: string;
  setSelectedTopic: (value: string) => void;
  selectedUniversity?: string;
  totalUsers?: number;
  totalStudents?: number;
  totalNotCompleted?: number;
}

const ParticipationCard = ({ 
  selectedTopic, 
  setSelectedTopic, 
  selectedUniversity = '', 
  totalUsers = 0,
  totalStudents = 0,
  totalNotCompleted = 0
}: ParticipationCardProps) => {
  // Dinamik ma'lumotlarni ishlatish
  const participated = totalUsers;
  const notParticipated = totalNotCompleted;
  const total = totalStudents;

  // Calculate percentage
  const notParticipatedPercentage = total > 0 ? ((notParticipated / total) * 100).toFixed(1) : '0';
  const participatedPercentage = total > 0 ? ((participated / total) * 100).toFixed(1) : '0';

  const data = {
    labels: ["Ishtirok etganlar", "Ishtirok etmaganlar"],
    datasets: [
      {
        data: [participated, notParticipated],
        backgroundColor: ['#10b981', '#ef4444'],
        borderWidth: 0,
        cutout: '60%'
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    animation: {
      animateRotate: true,
      animateScale: true,
      duration: 500,
      easing: 'easeOutQuart' as const
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        backgroundColor: '#1e293b',
        padding: 12,
        borderRadius: 8,
        titleColor: '#fff',
        bodyColor: '#fff',
        callbacks: {
          label: function (context: any) {
            const label = context.label || '';
            const value = context.parsed || 0;
            const total = context.dataset.data.reduce((a: number, b: number) => a + b, 0);
            const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
            return `${label}: ${value.toLocaleString()} (${percentage}%)`;
          }
        }
      }
    }
  };

  const legendData = [
    {
      color: 'purple',
      label: "Ishtirok etganlar",
      value: participated.toLocaleString()
    },
    {
      color: 'red',
      label: "Ishtirok etmaganlar",
      value: notParticipated.toLocaleString()
    },
  ];

  return (
    <div className="participation-card">
      <div className="participation-header">
        <h3>Ishtirok darajasi</h3>
      </div>
      <div className="circular-stats-large">
        <div className="chart-wrapper">
          <div className="center-percentage">
            <div className="percentage-value">{total.toLocaleString()}</div>
            <div className="percentage-label">Jami</div>
          </div>
          <Doughnut data={data} options={options} />
        </div>
        <div className="circular-legend">
          {legendData.map((item, index) => (
            <div key={index} className="legend-item">
              <span className={`legend-dot ${item.color}`}></span>
              <span className="legend-label">{item.label}</span>
              <span className="legend-value">{item.value}</span>
            </div>
          ))}
        </div>
        <div className="participation-summary">
          <div className="summary-item">
            <div className="summary-label">Ishtirok etmaganlar</div>
            <div className="summary-value">{notParticipatedPercentage}%</div>
          </div>
          <div className="summary-divider"></div>
          <div className="summary-item">
            <div className="summary-label">Ishtirok etganlar</div>
            <div className="summary-value">{participatedPercentage}%</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParticipationCard;
